/**
 * How a chat request sends its tools (CACHE step 2, 2026-10-19; the server's
 * TOOL_DELIVERY, tools/tool-delivery.ts): `fixed`, one list on every round with
 * use_tool for what get_tools loads; `legacy`, the list before this step.
 *
 * No imports: companion-api takes the type by path with `import type`, as it
 * does from tool-manifest.ts (its image has no copy of this package, and its
 * NodeNext build cannot read the rest of it: extensionless imports, DOM types).
 */

export const TOOL_DELIVERIES = ['fixed', 'legacy'] as const
export type ToolDelivery = (typeof TOOL_DELIVERIES)[number]
